import React from 'react'
import { observer } from 'mobx-react'
import { modalLayer } from '@utils'
import { AddGiftCar } from '../../../modal'
import './index.scss'

const AddGift = () => {
  const onclick = () => {
    modalLayer(AddGiftCar, null, 'selectTipModal')
  }

  return (
    <div className='add-gift' data-cypid='addGift' onClick={onclick}>
      <span>+{i18n.t('pay.useGiftCard')}</span>
    </div>
  )
}

export default observer(AddGift)
